import React from "react";
import { motion } from "framer-motion";
import { ListMusic } from "lucide-react";
import { SectionHeader } from "@/components/site/primitives";
import { toast } from "@/components/ui/sonner";
import { fadeUp, stagger } from "@/lib/motion";
import { CURATED_LISTS } from "@/data";

const spineTone = {
  coral: "from-coral to-[#b85e58]",
  yellow: "from-yellow to-[#e0b164]",
  sage: "from-sage to-[#a9c39d]",
  blue: "from-blue to-[#6b808b]",
};

export default function CuratedLists() {
  return (
    <section className="u-container mt-14 md:mt-20" data-testid="explore-curated-lists">
      <SectionHeader eyebrow="Editorial & community collections" title="Curated for You" />
      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.25 }} className="mt-8 grid gap-4 sm:grid-cols-2">
        {CURATED_LISTS.map((list, i) => (
          <motion.button
            key={list.title}
            type="button"
            variants={fadeUp}
            custom={i}
            onClick={() => toast("Full collections are coming soon.")}
            data-testid={`explore-list-${i}`}
            className={`group relative flex min-h-[132px] flex-col justify-between overflow-hidden rounded-2xl bg-gradient-to-br p-5 text-left shadow-card transition-transform duration-300 ease-soft hover:-translate-y-1 ${spineTone[list.tone]}`}
          >
            <ListMusic className="h-5 w-5 text-white/70" />
            <div>
              <p className="font-display text-lg font-semibold leading-snug text-white text-balance">{list.title}</p>
              <p className="mt-1 text-xs font-medium text-white/80">{list.curator} · {list.count} books</p>
            </div>
          </motion.button>
        ))}
      </motion.div>
    </section>
  );
}
